import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import AdaWidget from '~/layout/components/AdaWidget';
import useHelpPageUrl from '~/layout/utils/useHelpPageUrl';
import { Link } from '~/techstyle-shared/next-routes';

import { createDataAutoTagString } from '../header/utils/createDataAutoTagString';
import { getBuilderDataAnalyticsProps } from '../header/utils/getBuilderDataAnalyticsProps';

const FooterLinkWrapper = styled.li`
  list-style: none;
`;

const StyledLink = styled.a`
  width: 100%;

  ${({ theme }) => theme.builderFooter.footerLink.link}
`;

const Label = styled.span`
  display: inline-block;
  font-size: 14px;

  ${({ theme }) => theme.builderFooter.footerLink.label}

  ${({ $isBold, theme }) => $isBold && theme.builderFooter.footerLink.bold}
`;

const OneTrustLink = styled.span`
  font-size: 14px;
  cursor: pointer;
  display: inline-block;

  ${({ theme }) => theme.builderFooter.footerLink.oneTrust}
`;

const openOneTrustSettings = (event) => {
  if (event) {
    event.preventDefault();
  }

  if (
    typeof window !== 'undefined' &&
    typeof window?.OneTrust?.ToggleInfoDisplay === 'function'
  ) {
    window.OneTrust.ToggleInfoDisplay();
  }
};

function getFooterLink({
  dataAutotag,
  isAccessibilityOption,
  isBold,
  isFaqLink,
  isOneTrust,
  linkText,
  linkUrl,
  helpPageUrl,
}) {
  if (isAccessibilityOption) {
    return (
      <AdaWidget
        data-ga-label="Footer_Memberservices_enableaccessibility"
        data-autotag={dataAutotag}
      >
        {linkText}
      </AdaWidget>
    );
  } else if (isFaqLink) {
    linkUrl = helpPageUrl;
  } else if (isOneTrust) {
    return (
      <OneTrustLink data-autotag={dataAutotag} onClick={openOneTrustSettings}>
        {linkText}
      </OneTrustLink>
    );
  }

  return (
    <Link href={linkUrl} passHref>
      <StyledLink title={linkText}>
        <Label $isBold={isBold}>{linkText}</Label>
      </StyledLink>
    </Link>
  );
}

function BuilderFooterLink({
  linkText,
  linkUrl,
  isAccessibilityOption,
  isBold,
  isFaqLink,
  isOneTrust,
  dataAnalytics,
}) {
  const helpPageUrl = useHelpPageUrl();
  const dataAutotag = dataAnalytics?.label
    ? createDataAutoTagString(dataAnalytics.label)
    : createDataAutoTagString(linkText);

  return (
    <FooterLinkWrapper
      data-builder-component-type="nav_link"
      data-autotag={dataAutotag}
      {...getBuilderDataAnalyticsProps(dataAnalytics)}
    >
      {getFooterLink({
        dataAutotag,
        isAccessibilityOption,
        isBold,
        isFaqLink,
        isOneTrust,
        linkText,
        linkUrl,
        helpPageUrl,
      })}
    </FooterLinkWrapper>
  );
}

BuilderFooterLink.propTypes = {
  dataAnalytics: PropTypes.shape({
    category: PropTypes.string,
    label: PropTypes.string,
  }),
  isAccessibilityOption: PropTypes.bool,
  isBold: PropTypes.bool,
  isFaqLink: PropTypes.bool,
  isOneTrust: PropTypes.bool,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
};

export default BuilderFooterLink;
